import { useGetUsersList } from "@birdwatch/client";
import { uniqBy } from "lodash-es";

import { MANAGER_ROLE_KEYS } from "@/libs/user-role";
import { UserRole } from "@/types/openapi-enum";

const TAKE_ALL = 9999;

export const useUsersUpdates = (placeId: string) => {
  const members = useGetUsersList()
    .filters({
      hasPlaces: placeId,
      isActivated: "true",
    })
    .includes("accounts")
    .sort("name")
    .take(TAKE_ALL)
    .get({ enabled: !!placeId });

  const technicians = useGetUsersList()
    .filters({
      roles: { in: [UserRole.Technician, UserRole.Evaluator].join(",") },
      isActivated: "true",
    })
    .includes("accounts")
    .sort("name")
    .take(TAKE_ALL)
    .get({ enabled: !!placeId });

  const managers = useGetUsersList()
    .filters({
      roles: { in: MANAGER_ROLE_KEYS.join(",") },
      isActivated: "true",
    })
    .includes("accounts")
    .sort("name")
    .take(TAKE_ALL)
    .get({ enabled: !!placeId });

  const data = placeId
    ? uniqBy(
        [
          ...(members.data ?? []),
          ...(technicians.data ?? []),
          ...(managers.data ?? []),
        ],
        "id",
      )
    : [];

  return {
    data,
    isLoading: members.isLoading || technicians.isLoading || managers.isLoading,
    isError: members.isError || technicians.isError || managers.isError,
  };
};
